import React, { useRef, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { apiFetch } from "../../api/api"; // Your api file

const NotebooksJournalsSection = ({ sectionTitle = "Notebooks & journals" }) => {
  const leftRef = useRef(null);
  const sectionRef = useRef(null);

  // States for API data
  const [products, setProducts] = useState([]);
  const [bannerImage, setBannerImage] = useState(null);

  useEffect(() => {
    // 1. Fetch Products from your API
    apiFetch("/home/notebooks.php", { auth: false })
      .then((res) => setProducts(res.data || []))
      .catch((err) => console.error("Error loading products:", err));

    // 2. Fetch Banner from your API
    apiFetch("/home/notebooks.php?type=banner", { auth: false })
      .then((res) => setBannerImage(res.data?.image_url))
      .catch((err) => console.error("Error loading banner:", err));
  }, []);

  return (
    <section
      ref={sectionRef}
      className="flex flex-col lg:flex-row w-full bg-white font-body overflow-hidden px-3 xs:px-4 sm:px-8 lg:px-[10%] h-auto lg:h-[600px]"
    >
      {/* Banner - top on mobile, right on desktop */}
      <div className="w-full lg:w-[45%] flex-shrink-0 lg:h-full flex flex-col pt-5 xs:pt-6 lg:pt-8 order-1 lg:order-2">
        <h2 className="text-xl xs:text-2xl sm:text-3xl lg:text-4xl font-serif italic text-[#111] text-center lg:text-right pr-0 lg:pr-4 mb-3 xs:mb-4 lg:mb-6">
          {sectionTitle}
        </h2>
        <div className="relative overflow-hidden w-full h-[200px] xs:h-[240px] sm:h-[300px] lg:h-auto lg:flex-grow bg-gray-100 rounded-lg lg:rounded-none shadow-sm lg:shadow-none">
          {bannerImage && (
            <img src={bannerImage} alt="Banner" className="w-full h-full object-cover" />
          )}
        </div>
      </div>

      {/* Product List - bottom on mobile, left on desktop */}
      <div
        ref={leftRef}
        data-lenis-prevent
        className="w-full lg:w-[55%] h-[420px] xs:h-[460px] sm:h-[500px] lg:h-full overflow-y-auto px-0 sm:px-4 lg:px-8 py-6 xs:py-8 lg:py-10 order-2 lg:order-1"
        style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
      >
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-2 gap-y-5 xs:gap-y-8 sm:gap-y-10 lg:gap-y-10 max-w-full lg:max-w-[600px] mx-auto gap-x-3 xs:gap-x-4 sm:gap-x-6 lg:gap-x-3">
          {products.map((p, index) => (
            <motion.div
              key={p.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: (index % 4) * 0.08 }}
            >
              <Link
                to={p.product_href || `/homenotebook/${p.id}`}
                className="flex flex-col items-center cursor-pointer group active:scale-[0.97] transition-transform"
              >
                <div className="w-full h-[130px] xs:h-[170px] sm:h-[210px] lg:h-[250px] flex items-end justify-center mb-2 xs:mb-3 lg:mb-4">
                  <img
                    src={p.image_url}
                    alt={p.name}
                    loading="lazy"
                    className="max-h-full max-w-[100%] object-contain transition-transform duration-300 group-hover:-translate-y-1.5 group-hover:scale-105"
                  />
                </div>
                <p className="text-[11.5px] xs:text-[12.5px] sm:text-[14px] font-bold text-[#111] text-center mb-0.5">
                  {p.name}
                </p>
                <p className="text-[10px] xs:text-[11px] sm:text-[12px] text-gray-500 text-center mb-1.5">
                  {p.subtitle}
                </p>
                <div className="flex items-center gap-1.5 justify-center">
                  <span className="text-[11px] font-bold text-[#111]">Rs. {p.new_price}</span>
                  {p.old_price && (
                    <span className="text-[10px] font-bold text-[#111] bg-[#fce954] px-1 rounded-sm line-through">
                      Rs. {p.old_price}
                    </span>
                  )}
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NotebooksJournalsSection;